import React from 'react';
import Icon from '../../../components/AppIcon';

const WellnessScoreCard = ({ score, trend, previousScore }) => {
  const getScoreColor = (score) => {
    if (score >= 80) return 'text-success';
    if (score >= 60) return 'text-warning';
    return 'text-error';
  };

  const getScoreBgColor = (score) => {
    if (score >= 80) return 'bg-success/10';
    if (score >= 60) return 'bg-warning/10';
    return 'bg-error/10';
  };

  const getTrendIcon = () => {
    if (trend > 0) return 'TrendingUp';
    if (trend < 0) return 'TrendingDown';
    return 'Minus';
  };

  const getTrendColor = () => {
    if (trend > 0) return 'text-success';
    if (trend < 0) return 'text-error';
    return 'text-muted-foreground';
  };

  return (
    <div className="bg-card rounded-xl p-4 md:p-6 lg:p-8 shadow-elevation-2 border border-border">
      <div className="flex items-start justify-between mb-4 md:mb-6">
        <div>
          <h3 className="text-base md:text-lg lg:text-xl font-semibold text-foreground mb-1 md:mb-2">
            Aggregate Financial Wellness Score
          </h3>
          <p className="text-xs md:text-sm text-muted-foreground">
            Organization-wide financial health metric
          </p>
        </div>
        <div className={`p-2 md:p-3 rounded-lg ${getScoreBgColor(score)}`}>
          <Icon name="Activity" size={20} className={getScoreColor(score)} />
        </div>
      </div>

      <div className="flex items-end gap-3 md:gap-4 mb-4 md:mb-6">
        <div className={`text-4xl md:text-5xl lg:text-6xl font-bold ${getScoreColor(score)}`}>
          {score}
        </div>
        <div className="flex items-center gap-1 md:gap-2 mb-2 md:mb-3">
          <Icon name={getTrendIcon()} size={20} className={getTrendColor()} />
          <span className={`text-sm md:text-base font-medium ${getTrendColor()}`}>
            {Math.abs(trend)}%
          </span>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-4 pt-4 md:pt-6 border-t border-border">
        <div>
          <p className="text-xs md:text-sm text-muted-foreground mb-1">Previous Period</p>
          <p className="text-base md:text-lg lg:text-xl font-semibold text-foreground">{previousScore}</p>
        </div>
        <div>
          <p className="text-xs md:text-sm text-muted-foreground mb-1">Total Employees</p>
          <p className="text-base md:text-lg lg:text-xl font-semibold text-foreground">1,247</p>
        </div>
      </div>
    </div>
  );
};

export default WellnessScoreCard;